import { GoogleMapsStructuredPlace } from '../interfaces/googleMapsInterfaces'
import { getPlacesByGeocode } from '../services/googleMapsServices'
import { formatGoogleAutoCompleteResponse } from '../utils/googleMapsUtils'

export function useMyLocation() {
  const getPosition = (): Promise<GoogleMapsStructuredPlace> => {
    return new Promise((resolve, reject) => {
      navigator?.geolocation?.getCurrentPosition(
        async ({ coords }) => {
          const { latitude, longitude } = coords

          const { isSuccess, data } = await getPlacesByGeocode({
            coordinates: {
              latitude,
              longitude
            }
          })

          if (!isSuccess || !data?.length) {
            reject(new Error('no found places'))
          }

          const filter = filterByTypes({
            places: data || []
          })

          const place = filter.length ? filter[0] : undefined

          if (!place?.placeId) {
            reject(new Error('no found place'))

            reject()
          }

          const {
            geometry,
            placeId,
            addressComponents,
            types,
            formattedAddress
          } = place

          const formatted = formatGoogleAutoCompleteResponse({
            place: {
              location: {
                latitude: geometry.location.lat(),
                longitude: geometry.location.lng()
              },
              id: placeId,
              addressComponents,
              types
            },
            originalfullAddress: formattedAddress
          })

          resolve(formatted)
        },
        (error: any) => {
          reject(error)
        }
      )
    })
  }

  /**
   * This function is used to filter the places by types.
   * @param {any[]} places places to filter
   */
  const filterByTypes = (params: { places: any[] }) => {
    const { places } = params

    const validTypes = [
      'administrative_area_level_3',
      'locality',
      'sublocality_level_1',
      'neighborhood',
      'premise',
      'street_address',
      'route'
    ]

    const result = places?.filter((item: any) => {
      return validTypes.some((type: any) => {
        return item.types.includes(type)
      })
    })

    return result
  }

  return {
    getPosition
  }
}
